import validator from 'validator';

export const emailValidator = validator.isEmail;

export const passwordValidator = password => {
    return password.length > 5;
}
